// Slot-layout primitive registry — DECISION-024.
//
// Each primitive registers itself at module import. The composer looks
// up the primitive by name from `manifest.slots.layoutAlgorithm`.
//
// A slot-layout primitive computes slot positions + orientations from
// manifest parameters + scene context. It does NOT place products —
// that's the composer's job once slot positions are known.

const _registry = new Map();

/**
 * @typedef {Object} SlotLayoutContext
 * @property {Object} anchor      Anchor entry (position, scale, rotationY, extras).
 * @property {Object} manifest    The full fixture manifest.
 * @property {Object} bodyMesh    The placed catalogue body mesh (THREE.Object3D); positions of named nodes can be queried.
 * @property {number} productCount Number of products GCG assigned to this anchor (drives adaptive count).
 */

/**
 * @typedef {Object} SlotLayoutResult
 * @property {Array<{ position: any, quaternion: any }>} slots   Per-slot world-space placement (THREE.Vector3 + THREE.Quaternion).
 * @property {Object=} extras                                     Algorithm-specific extras (e.g., lane bounds, hero-extract position).
 */

/**
 * Register a slot-layout primitive.
 * @param {string} name
 * @param {(ctx: SlotLayoutContext) => SlotLayoutResult} computeFn
 */
export function registerSlotLayout(name, computeFn) {
	if (_registry.has(name)) {
		console.warn(`[slot-layouts] '${name}' already registered; overwriting`);
	}
	_registry.set(name, computeFn);
}

export function getSlotLayout(name) {
	return _registry.get(name) || null;
}

export function listSlotLayouts() {
	return Array.from(_registry.keys());
}
